import { NonTimezoneSensitiveDate } from '@commenda/utils';
import AgendaEventCard from './AgendaEventCard';
import {
  CALENDAR_TEXT_SECONDARY,
  CALENDAR_TODAY_ACCENT,
} from './calendar.constants';
import { RbcEvent } from './calendar.types';

export type AgendaMode = 'horizontal' | 'stacked';

interface AgendaDateGroupProps {
  /** ISO 8601 calendar date (YYYY-MM-DD). */
  date: string;
  events: RbcEvent[];
  isToday: boolean;
  mode: AgendaMode;
  onSelectEvent: (event: RbcEvent) => void;
  onFilingMutated?: () => void;
}

const AgendaDateGroup = ({
  date,
  events,
  isToday,
  mode,
  onSelectEvent,
  onFilingMutated,
}: AgendaDateGroupProps) => {
  const labelColor = isToday ? CALENDAR_TODAY_ACCENT : CALENDAR_TEXT_SECONDARY;
  const dateLabel = NonTimezoneSensitiveDate.fromISO8601String(date).format(
    'dddd, MMMM D'
  );

  if (mode === 'stacked') {
    return (
      <div className="flex flex-col w-full gap-1">
        <div className="px-2 py-1">
          <span
            className="txt-small-bold whitespace-nowrap"
            style={{ color: labelColor }}
          >
            {dateLabel}
          </span>
        </div>
        <div className="flex flex-col gap-1">
          {events.map((event) => (
            <AgendaEventCard
              key={event.id}
              event={event}
              onSelect={() => onSelectEvent(event)}
              mode={mode}
              onFilingMutated={onFilingMutated}
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap shrink-0 w-full min-h-[70px] gap-x-6 gap-y-1">
      <div className="shrink-0 flex flex-col w-[276px] p-2">
        <span
          className="txt-small-bold whitespace-nowrap"
          style={{ color: labelColor }}
        >
          {dateLabel}
        </span>
      </div>

      <div className="flex flex-col flex-[1_1_320px] min-w-0 gap-1">
        {events.map((event) => (
          <AgendaEventCard
            key={event.id}
            event={event}
            onSelect={() => onSelectEvent(event)}
            mode={mode}
            onFilingMutated={onFilingMutated}
          />
        ))}
      </div>
    </div>
  );
};

export default AgendaDateGroup;
